<!--
 * @Author: lsq
 * @Date: 2024-03-12 11:32:43
 * @LastEditTime: 2025-09-08 16:37:46
 * @LastEditors: lsq
 * @Description: 
 * @FilePath: /sunpay-web/src/components/layout/horizontalIndex.vue
-->


<template>
  <el-container class="layout-main-container">
    <el-header class="layout-main-header">
      <layout-header />
    </el-header>
    <el-container class="sub-container">
      <!-- <el-aside
        v-if="$route.meta?.horizontalIndex && !$route.meta?.hidden"
        class="flex"
        :class="{'shrink': shrink}"
      >
        <navigation direction="vertical" :shrink="shrink" :class="{'shrink': shrink}" />
        <div class="shrink-btn">
          <span
            @click="shrink=!shrink"
            class="icon iconfont"
            :class="shrink? 'icon-right-arrow' : 'icon-left-arrow'"
          ></span>
        </div>
      </el-aside> -->
      <el-aside>
        <top-menu></top-menu>
      </el-aside>
      <el-main style="padding:0">
        <tm-router-view></tm-router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref } from "vue";
import LayoutHeader from "./LayoutHeader";
import tmRouterView from "@/components/layout/RouterView.vue";
import Navigation from "./Navigation.vue";
import TopMenu from "./TopMenu.vue";
import { useRoute } from 'vue-router'
const $route = useRoute()
const shrink = ref(false);
</script>

<style lang="less" scoped>
.sub-container {
  padding: 0;
  height: calc(100% - 74px);
}
.flex {
  display: flex;
  &.el-aside {
    width: 224px;
    height: 100%;
    transition: width 0.4s;
    &.shrink {
      width: 80px;
      transition: width 0.4s;
    }
  }
}
.shrink-btn {
  position: relative;
  width: 16px;
  >span {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color: #8A9ABB;
    border: 1px solid #DAE2F0;
    background: #F6F8FA;
    border-radius: 0px 2px 2px 0px;
    font-size: 12px;
    cursor: pointer;
  }
}
</style>
